module.exports = __webpack_public_path__ + "static/media/mountains-big.6d5c300e.jpg";